import {
  axiosInstance,
  adminAxiosInstance,
  GET_ALL_COMPLETED_COURSE_URL,
  GET_ALL_COMPLETED_SUBJECT_URL,
  GET_ALL_COMPLETED_SUBTOPIC_URL,
  GET_ALL_COMPLETED_TOPIC_URL,
  UPDATE_COMPLETED_COURSE_URL,
  UPDATE_COMPLETED_SUBJECT_URL,
  UPDATE_COMPLETED_SUBTOPIC_URL,
  UPDATE_COMPLETED_TOPIC_URL,
  TEACHER_UPDATE_COMPLETED_COURSE_URL,
  TEACHER_UPDATE_COMPLETED_SUBJECT_URL,
  TEACHER_UPDATE_COMPLETED_TOPIC_URL,
  TEACHER_UPDATE_COMPLETED_SUBTOPIC_URL,
  TEACHER_GET_COMPLETED_COURSE_URL,
  TEACHER_GET_COMPLETED_SUBJECT_URL,
  TEACHER_GET_COMPLETED_TOPIC_URL,
  TEACHER_GET_COMPLETED_SUBTOPIC_URL,
  GET_COURSE_SUBJECT_SUMMARY_URL,
  GET_SUBJECT_TOPIC_SUMMARY_URL,
  GET_TOPIC_SUBTOPIC_SUMMARY_URL,
  GET_ONE_COURSE_COMPLETED_URL,
} from "../apiurls/apiurls";
import {
  GET_ALL_COURSES,
  GET_COURSE_BY_KEY,
  GET_ALL_COURSE_PAGE_CONTENT,
  GET_COURSE_PAGE_CONTENT_BY_ID,
  GET_BREADCRUMBS,
  GET_ALL_COURSE_INSTITUTION_PAGE_CONTENT,
  GET_COURSE_INSTITUTION_PAGE_CONTENT_BY_ID,
} from "../apiurls/apiurls";
import Cookies from "js-cookie";

export const getAllCourses = async () => {
  try {
    const response = await axiosInstance.get(GET_ALL_COURSES);
    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw error;
  }
};

export const getCourseByKey = async (key) => {
  try {
    const response = await axiosInstance.get(`${GET_COURSE_BY_KEY}?key=${key}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching course by key:", error);
    throw error;
  }
};

export const getAllCoursePageContent = async (courseKey) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ALL_COURSE_PAGE_CONTENT}?course_key=${courseKey}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all course page content:", error);
    throw error;
  }
};

export const getAllCourseInstitutionPageContent = async (courseKey) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ALL_COURSE_INSTITUTION_PAGE_CONTENT}?course_key=${courseKey}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all course institution page content:", error);
    throw error;
  }
};

export const getCoursePageContentById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${GET_COURSE_PAGE_CONTENT_BY_ID}?id=${id}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching course page content by id:", error);
    throw error;
  }
};

export const getCourseInstitutionPageContentById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${GET_COURSE_INSTITUTION_PAGE_CONTENT_BY_ID}?id=${id}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching course institution page content by id:", error);
    throw error;
  }
};

export const getBreadcrumbs = async (courseKey) => {
  try {
    const response = await axiosInstance.get(GET_BREADCRUMBS, {
      params: { course_key: courseKey },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching breadcrumbs:", error);
    throw error;
  }
};

export const getCompletedCourseApi = async (title, key) => {
  let url = "";

  const storedUser = Cookies.get("user");
  let isAdmin = false;
  if (storedUser) {
    try {
      const user = JSON.parse(storedUser);
      isAdmin = !!user.admin;
    } catch (e) {
      console.error("Error parsing user from session storage", e);
    }
  }

  if (isAdmin) {
    if (title === "course") {
      url = TEACHER_GET_COMPLETED_COURSE_URL;
    } else if (title === "subject") {
      url = TEACHER_GET_COMPLETED_SUBJECT_URL;
    } else if (title === "topic") {
      url = TEACHER_GET_COMPLETED_TOPIC_URL;
    } else {
      url = TEACHER_GET_COMPLETED_SUBTOPIC_URL;
    }
  } else {
    if (title === "course") {
      url = GET_ALL_COMPLETED_COURSE_URL;
    } else if (title === "subject") {
      url = GET_ALL_COMPLETED_SUBJECT_URL;
    } else if (title === "topic") {
      url = GET_ALL_COMPLETED_TOPIC_URL;
    } else {
      url = GET_ALL_COMPLETED_SUBTOPIC_URL;
    }
  }

  let queryParams = `?title=${title}&key=${key}`;

  if (isAdmin) {
    const batchId = Cookies.get("batchId");
    if (batchId) {
      queryParams += `&batches=${batchId}`;
    }
  }

  const finalUrl = `${url}${queryParams}`;

  try {
    const apiInstance = isAdmin ? adminAxiosInstance : axiosInstance;
    const response = await apiInstance.get(finalUrl);
    return response;
  } catch (error) {
    console.error("Error fetching completed status:", error);
    throw error;
  }
};
export const updateCompletedCourseApi = async (title, payload) => {
  let url = "";

  const storedUser = Cookies.get("user");
  let isAdmin = false;
  if (storedUser) {
    try {
      const user = JSON.parse(storedUser);
      isAdmin = !!user.admin;
    } catch (e) {
      console.error("Error parsing user from session storage", e);
    }
  }

  if (title === "course") {
    url = isAdmin
      ? TEACHER_UPDATE_COMPLETED_COURSE_URL
      : UPDATE_COMPLETED_COURSE_URL;
  } else if (title === "subject") {
    url = isAdmin
      ? TEACHER_UPDATE_COMPLETED_SUBJECT_URL
      : UPDATE_COMPLETED_SUBJECT_URL;
  } else if (title === "topic") {
    url = isAdmin
      ? TEACHER_UPDATE_COMPLETED_TOPIC_URL
      : UPDATE_COMPLETED_TOPIC_URL;
  } else {
    url = isAdmin
      ? TEACHER_UPDATE_COMPLETED_SUBTOPIC_URL
      : UPDATE_COMPLETED_SUBTOPIC_URL;
  }

  if (isAdmin) {
    const batchId = Cookies.get("batchId");
    if (batchId) {
      payload = { ...payload, batches: batchId };
    }
  }
  try {
    const apiInstance = isAdmin ? adminAxiosInstance : axiosInstance;
    const response = await apiInstance.post(url, payload);
    return response;
  } catch (error) {
    console.error("Error fetching breadcrumbs:", error);
    throw error;
  }
};

export const getCompletionSummaryApi = async (title, key) => {
  let url = "";

  const storedUser = Cookies.get("user");
  let isAdmin = false;
  if (storedUser) {
    try {
      const user = JSON.parse(storedUser);
      isAdmin = !!user.admin;
    } catch (e) {
      console.error("Error parsing user from session storage", e);
    }
  }

  if (title === "course") {
    url = GET_COURSE_SUBJECT_SUMMARY_URL;
  } else if (title === "subject") {
    url = GET_SUBJECT_TOPIC_SUMMARY_URL;
  } else if (title === "topic") {
    url = GET_TOPIC_SUBTOPIC_SUMMARY_URL;
  }

  let queryParams = `?title=${title}&key=${key}`;

  if (isAdmin) {
    const batchId = Cookies.get("batchId");
    if (batchId) {
      queryParams += `&batches=${batchId}`;
    }
  }

  const finalUrl = `${url}${queryParams}`;

  try {
    if (!isAdmin) {
      const apiInstance = isAdmin ? adminAxiosInstance : axiosInstance;
      const response = await apiInstance.get(finalUrl);
      return response;
    }
  } catch (error) {
    console.error("Error fetching completion summary:", error);
    throw error;
  }
};

export const getOneCourseCompletedApi = async (pageId) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ONE_COURSE_COMPLETED_URL}?page_id=${pageId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching one course completed:", error);
    throw error;
  }
};
